export const navLinks = [
  {
    id: 1,
    linkText: "Home",
    url: "/",
  },
  {
    id: 2,
    linkText: "About Us",
    url: "/about-us",
  },
  {
    id: 3,
    linkText: "Gallery",
    url: "/gallery",
  },
  {
    id: 4,
    linkText: "Contact",
    url: "/contact",
  },
  {
    id: 5,
    linkText: "Team",
    url: "/team",
  },
  {
    id: 6,
    linkText: "Faq",
    url: "/faqs",
  },
];
